import styles from './CleanCard.module.scss';
import { ReactNode } from 'react';

interface ICleanCard {
  children: ReactNode;
}

export const CleanCardRoot = ({ children }: ICleanCard) => {
  return (
    <div className={`clear_card__item ${styles.clear_card__item}`}>
      {children}
    </div>
  );
};
